import React from 'react';
import { useAuthorization } from 'framework/authorization';
import LinkButton from './LinkButton';
import useFieldHelper from '../../field/fieldHelper';
import EditIcon from '@mui/icons-material/EditOutlined';
import { ButtonProps } from '../../mui-builder/Button/Button';

export interface EditButtonProps extends ButtonProps {
  icon?: React.ReactElement;
  isSmall?: boolean;
  source?: string;
  outline?: boolean;
  color?: BasicColors;
  hasIcon?: boolean;
  label?: string;
  permissionToCheck?: Nullable<string | string[]>;
  isVisible?: boolean | ((data: any) => boolean);
}

interface GenericEditButtonProps extends EditButtonProps {
  path: string | ((id?: Nullable<string | number>) => string);
}

const EditButton = ({
  path: initialUrl,
  permissionToCheck = 'UPDATE',
  icon,
  isSmall = false,
  hasIcon = false,
  label,
  ...props
}: GenericEditButtonProps) => {
  const { getValue } = useFieldHelper(props);
  const { isGranted } = useAuthorization();

  const path = typeof initialUrl === 'function' ? initialUrl(getValue() as string | number) : initialUrl;

  return !permissionToCheck || isGranted(permissionToCheck) ? (
    <LinkButton
      url={path}
      size={isSmall ? 'small' : 'medium'}
      {...props}
      startIcon={hasIcon ? <EditIcon fontSize="small" /> : null}
    >
      {label || 'Edit'}
    </LinkButton>
  ) : null;
};

export default EditButton;
